module.exports = __webpack_public_path__ + "img/inbestgo.be685950.svg";